import { useEffect, useState } from "react";

const navItems = [
  { href: "#hot", label: "正在热吃" },
  { href: "#channels", label: "频道目录" },
  { href: "#ranking", label: "热瓜榜单" },
  { href: "#why", label: "为何免费" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const light = !scrolled && !open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        light ? "bg-transparent" : "bg-background-50/90 backdrop-blur border-b border-background-200/70"
      }`}
    >
      <div className="mx-auto flex max-w-[1200px] items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="group flex items-center gap-2.5" aria-label="吃瓜免费 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold shadow-none transition-transform group-hover:-rotate-6">
            瓜
          </span>
          <span
            className={`font-heading text-xl font-bold tracking-wide transition-colors ${
              light ? "text-white" : "text-foreground-900"
            }`}
          >
            吃瓜免费
          </span>
          <span
            className={`ml-1 hidden rounded-full px-2 py-0.5 text-[11px] font-medium sm:inline-flex ${
              light ? "bg-white/20 text-white" : "bg-accent-100 text-accent-800"
            }`}
          >
            全解锁
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                light
                  ? "text-white/85 hover:bg-white/15 hover:text-white"
                  : "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#hot"
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors ${
              light ? "text-white/90 hover:text-white" : "text-foreground-700 hover:text-primary-800"
            }`}
          >
            <i className="ri-search-line text-base" />
            搜个瓜
          </a>
          <a
            href="#hot"
            className="inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            马上开吃
            <i className="ri-arrow-right-line text-base" />
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`inline-flex h-10 w-10 items-center justify-center rounded-md lg:hidden transition-colors ${
            light ? "text-white hover:bg-white/15" : "text-foreground-800 hover:bg-background-200"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50/95 backdrop-blur">
          <nav className="mx-auto flex max-w-[1200px] flex-col gap-1 px-4 md:px-6 py-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#hot"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600"
            >
              马上开吃
              <i className="ri-arrow-right-line text-base" />
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}